import React from 'react';
import Barras from '../home/Barras';
import { AREAS_EM_ORDEM, PESOS, ROTULO_DA_AREA, decimalEm } from '../home/amostra';
import { useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/Notas.css';

const SEM_PERDA = Object.fromEntries(AREAS_EM_ORDEM.map((area) => [area, 0]));

/**
 * A figura real de um post na lista do blog, escolhida por `capa.figura`. Hoje
 * só existe `'nota'`: os cinco pesos, com as barras da home inteiras, sem
 * nenhuma perda. Post sem figura não ganha imagem; o título faz esse papel.
 */
const FiguraDoPost = ({ figura }) => {
  const { t } = useIdioma();
  const { locale } = useFormato();
  if (figura !== 'nota') return null;

  const rotulo = (area) => t(ROTULO_DA_AREA[area]);
  const lista = AREAS_EM_ORDEM.map((area) => `${rotulo(area)} ${PESOS[area]}`).join(', ');

  return (
    <figure className="notas-figura" data-ui>
      <p className="nh-ui-titulo">{t('notas.figuraTitulo')}</p>
      <div className="notas-figura-barras" role="img" aria-label={t('notas.figuraRotulo', { lista })}>
        <Barras
          areas={AREAS_EM_ORDEM}
          pesos={PESOS}
          perdas={SEM_PERDA}
          rotulo={rotulo}
          decimal={decimalEm(locale)}
        />
      </div>
      <figcaption>{t('notas.figuraLegenda')}</figcaption>
    </figure>
  );
};

export default FiguraDoPost;
